import type { BlockExport } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { UserCard as Block } from "./UserCardBlock";
import { defaultData } from "./UserCardDefaultData";
import imagePreview from "./user_card_preview.png";

export const UserCardBlock: BlockExport = {
  type: "component",
  Block,
  imagePreview: {
    type: "image-url",
    lg: imagePreview,
  },
  defaultData,
  meta: {
    name: "User Card",
    version: 1,
    nameI18n: "builder_ui.block_type.user_card",
    isHidden: true,
    props: {
      image: {
        name: "Image",
        nameI18n: "builder_ui.prop_type.image",
        prop: "children",
        type: "children",
        accepts: ["Basic", "Media", "Text", "Actions", "Layout"],
      },
      header: {
        name: "Header",
        nameI18n: "builder_ui.prop_type.header",
        prop: "children",
        type: "children",
        accepts: ["Basic", "Media", "Text", "Actions", "Layout"],
      },
      description: {
        name: "Description",
        nameI18n: "builder_ui.prop_type.description",
        prop: "children",
        type: "children",
        accepts: ["Basic", "Media", "Text", "Actions", "Layout"],
      },
    },
  },
};
